<template>
  <modal :show="show" @change="$emit('change',$event)" width="400">
      <template v-slot:header>
        <span class="fs-22">{{$t('modals.modalCheckMeter.warning')}}</span>
      </template>
      <template v-slot:main>
        <div class="modal-content">
          <div class="tes-text modal-content-text">
            {{$t('modals.modalCheckMeter.infoPart1').split('_')[0]}}<br>{{$t('modals.modalCheckMeter.infoPart1').split('_')[1]}}<br>{{$t('modals.modalCheckMeter.infoPart1').split('_')[2]}}
            <span class="red--text" v-if = "currentLocale === 'ru'">{{date}}</span>
            <span class="red--text" v-else>{{formattedDate}}</span>
            {{$t('modals.modalCheckMeter.infoPart2')}}
          </div>
        </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters } from "vuex";

export default {
  name: "ModalReadingsInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
        date: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("locale",["currentLocale"]),
    formattedDate() {
      if (!this.date) return this.date;  
      let result = String(this.date);
      
      return result.replace('дней', 'көн').replace('дня', 'көн').replace('день', 'көн').replace('месяц', 'ай');
    }
  },
  methods: {},
  created() {},
  watch: {}
};
</script>

<style lang="scss">
.modal-content-text {
  text-align: center;
  font-size: 20px;
  padding: 10px;
}
</style>